import { render, staticRenderFns } from "./CustomerDetail7.vue?vue&type=template&id=21f62f78&scoped=true"
import script from "./CustomerDetail7.vue?vue&type=script&lang=js"
export * from "./CustomerDetail7.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail7.vue?vue&type=style&index=0&id=21f62f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f62f78",
  null
  
)

export default component.exports